import React from 'react';
import { NavLink } from 'react-router-dom';
import svgPaths from "./svg-n7w9hotcin";
import SessionDropdown from '../components/SessionDropdown';

type BlockMenuProps = {
  onLogout: () => void;
  showSessionControls?: boolean;
  appearance?: 'default' | 'agent';
};

export default function BlockMenu({ onLogout, showSessionControls = true, appearance = 'default' }: BlockMenuProps) {
  const navigationClassName = ({ isActive }: { isActive: boolean }) => (
    `rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${isActive
      ? 'bg-[#eef4ff] text-[#165BFB]'
      : 'text-[#676d7d] hover:bg-[#f6f8ff] hover:text-[#212736]'}`
  );

  return (
    <div className="min-h-[88px] w-full relative border-b border-[#EDF0F5] flex flex-wrap items-center gap-3 px-4 py-3 md:px-8">
      {/* Logo */}
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-3 md:gap-5">
        <div className="hidden h-[24.114px] w-[159px] flex-shrink-0 sm:block">
          <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 159 25">
            <g>
              <path d={svgPaths.p31795600} fill="#212736" />
              <path d={svgPaths.p8ade500} fill="#212736" />
            </g>
          </svg>
        </div>
        <nav className="flex flex-wrap items-center gap-1" aria-label="Main navigation">
          <NavLink to="/" end className={navigationClassName}>chat Evo agent</NavLink>
          <NavLink to="/text-quick-actions" className={navigationClassName}>Text quick actions</NavLink>
          <NavLink to="/site-briefs" className={navigationClassName}>Vibe site briefs</NavLink>
          <NavLink to="/site-builder" className={navigationClassName}>Vibe site sessions</NavLink>
        </nav>
      </div>
      {/* Center: session controls */}
      <div className={appearance === 'agent' ? 'agent-header-sessions flex items-center justify-center' : 'flex items-center justify-center'}>
        {showSessionControls && <SessionDropdown appearance={appearance} />}
      </div>
      {/* Right: account controls */}
      <div className="flex items-center justify-end">
        <button
          onClick={onLogout}
          className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
          aria-label="Logout"
        >
          Logout
        </button>
      </div>
    </div>
  );
}
